module.exports = __webpack_public_path__ + "static/media/wc.4c2c6d11.mp3";